<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<blockquote>
<blockquote>
<p class="para"><a id="page_2"></a><strong><span class="smallcaps">FORGE BOOKS BY LARRY BOND</span></strong></p>
<p class="para"> </p>
<p class="para"><em>Dangerous Ground</em></p>
<p class="para"><em>Cold Choices</em></p>
<p class="linespace"> </p>
<p class="para"><strong><span class="smallcaps">FORGE BOOKS BY LARRY BOND<br/>AND JIM DEFELICE</span></strong></p>
<p class="para"> </p>
<p class="para"><em>Larry Bond’s First Team</em></p>
<p class="para"><em>Larry Bond’s First Team: Angels of Wrath</em></p>
<p class="para"><em>Larry Bond’s First Team: Fires of War</em></p>
<p class="para"><em>Larry Bond’s First Team: Soul of the Assassin</em></p>
</blockquote>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abouttheauthor.vue?4d4f87f4